import { Navigate, useLocation } from 'react-router-dom';

import { AppLoading } from 'components/AppLoading';
import { useUser } from 'global/UserContext';

/**
 * RootRedirect Component
 *
 * Handles navigation from the root path (/) based on authentication state.
 * - If not authenticated: redirects to /login
 * - If authenticated: redirects to /cockpit (or last saved route)
 * - Preserves intended destination for post-login redirect
 */
export const RootRedirect = () => {
  const { token, isLoading } = useUser();
  const location = useLocation();

  // Wait for authentication check to complete
  if (isLoading) {
    return <AppLoading />;
  }

  // Not authenticated: redirect to login
  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Authenticated: redirect to last route or default to cockpit
  const lastRoute = sessionStorage.getItem('lastRoute');
  const destination = lastRoute && lastRoute !== '/' ? lastRoute : '/cockpit';

  return <Navigate to={destination} replace />;
};

export default RootRedirect;
